import { axiosInstance } from "./BaseService";

const HOME_URL = '/home';

export const fetchHome = async () => {
  try {
    const response = await axiosInstance.get(HOME_URL);
    return response.data;
  } catch (err) {
    throw err;
  }
};
